export const environment = {
  name: "stg",
  debug: true,
  apiUrl: '/',
  // apiUrl: 'https://training-stg.rentwise.org/',
  courses: {
    cheatQuizzes: false,
    fastForward: false
  },
  recaptcha: {
    enabled: true,
    siteKey: '6LepK-IrAAAAAOTXieYXdgnCH-5D6RrjYh0ig1eQ'
  },
  reciteMe: {
    enabled: true,
    clientKey: '9e3b84c70d2fc34efcc993837348a5d9a6f10645'
  },
  paypal: {
    clientId: 'sb'
  },
  tawk: {
    knowledgeBaseUrl: 'https://rentwise-staging.tawk.help'
  },
  aws: {
    assetsS3Url: 'https://rentwise-training-dev.s3.us-east-1.amazonaws.com/assets',
    assetsCdnUrl: 'https://assets.training-stg.rentwise.org'
  }
};
